import LayoutManager from './LayoutManager';

export default LayoutManager;
